// extracted by mini-css-extract-plugin
export var cards = "Recommendations-module--cards--b649e";
export var divider = "Recommendations-module--divider--6167b";
export var main__container = "Recommendations-module--main__container--3d1aa";